import { Float, ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { ChancenEventlog } from './ChancenEventlog.js';

// Thanks xml...
export enum XAPIVerb {
  ANSWERED = 'http://adlnet.gov/expapi/verbs/answered',
  INTERACTED = 'http://adlnet.gov/expapi/verbs/interacted',
  ATTEMPTED = 'http://adlnet.gov/expapi/verbs/attempted',
  PROGRESSED = 'http://adlnet.gov/expapi/verbs/progressed',
}

@Entity()
export class XAPIScore extends AdornisEntity {
  public static override _class = 'XAPIScore';

  @Field(type => Float)
  public min!: number;
  @Field(type => Float)
  public max!: number;
  @Field(type => Float)
  public raw!: number;
  @Field(type => Float)
  public scaled!: number;
}

@Entity()
export class XAPIResult extends AdornisEntity {
  public static override _class = 'XAPIResult';

  @Field(type => Boolean)
  public completion!: boolean;
  @Field(type => String)
  public duration!: string;
  @Field(type => String)
  public response!: string;
  @Field(type => XAPIScore)
  public score!: XAPIScore;
  @Field(type => Boolean)
  public success!: boolean; // this should be what you are interested in
}

@Entity()
export class XAPIEventlog extends ChancenEventlog {
  public static override _class = 'XAPIEventlog';

  constructor(doc: PartialEntityData<XAPIEventlog>) {
    super(doc);
  }

  @Field(type => ID, {
    default: v => v ?? '',
  })
  public lessonID!: string;
  @Field(type => ID, {
    default: v => v ?? '',
  })
  public contentID!: string;
  @Field(type => ID, {
    default: v => v ?? '',
  })
  public h5pContentID!: string;
  @Field(type => String, {
    default: v => v ?? '',
  })
  public verb!: XAPIVerb;
  /** only set if verb === answered */
  @Field(type => XAPIResult)
  public XApiResult?: XAPIResult;

  @Field(type => Boolean, {
    default: v => v ?? false,
  })
  public result!: boolean;
}
